import React, { useState } from "react";
import { CompactPicker } from "react-color";
import OutsideClickHandler from "react-outside-click-handler";
import { useSelector } from "react-redux";
import Select from "react-select";
import { useAddProjectMutation } from "../../features/project/projectApi";
import { useGetAllTeamsQuery } from "../../features/team/teamApi";

export default function ProjectModal({ close, state }) {
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [color, setColor] = useState("");
    const [getSelectTeam, setSelectTeam] = useState("");
    // user info
    const { user } = useSelector((state) => state.auth) || {};
    // add project api
    const [addProjectApi] = useAddProjectMutation();
    // get team api
    const { data: getTeams } =
        useGetAllTeamsQuery(undefined, {
            refetchOnMountOrArgChange: true,
        }) || [];

    const option = getTeams?.map((team) => {
        return {
            label: team.category,
            value: team.id,
        };
    });

    // add project submit handler
    const submitAddTeam = (e) => {
        e.preventDefault();

        if (
            name !== "" &&
            description !== "" &&
            color !== "" &&
            getSelectTeam !== ""
        ) {
            addProjectApi({
                position: "backlog",
                name,
                description,
                color,
                creator: user,
                teamId: getSelectTeam,
                date: new Date().getTime(),
            });
            state(false);
        } else {
            alert("Form inputs is required!");
        }
    };

    return (
        <>
            <div
                className="fixed inset-0 backdrop-blur-sm z-10"
                style={{ marginLeft: 0 }}
            >
                <OutsideClickHandler onOutsideClick={() => close()}>
                    <div className="w-6/12 rounded bg-white p-10 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                        <h4 className="text-2xl font-bold pb-10">
                            Create Project
                        </h4>
                        <form onSubmit={submitAddTeam}>
                            <div className="mb-3">
                                <input
                                    type="text"
                                    className="h-10 w-full border px-3 text-sm focus:outline-none rounded border-[#FF5733]"
                                    placeholder="Project Name"
                                    required
                                    onChange={(e) => setName(e.target.value)}
                                    value={name}
                                />
                            </div>
                            <div className="mb-3">
                                <textarea
                                    className="h-32 w-full border px-3 pt-2 text-sm focus:outline-none rounded border-[#FF5733]"
                                    placeholder="Description"
                                    required
                                    onChange={(e) =>
                                        setDescription(e.target.value)
                                    }
                                    value={description}
                                />
                            </div>
                            <div className="mb-3">
                                <Select
                                    styles={{
                                        border: "1px solid red",
                                    }}
                                    options={option}
                                    onChange={(value) =>
                                        setSelectTeam(value.value)
                                    }
                                    required
                                    className="text-sm"
                                    placeholder="Add project with a team."
                                />
                            </div>
                            <div className="mb-3">
                                <CompactPicker
                                    onChange={(color) => setColor(color.hex)}
                                />
                            </div>
                            <button className="h-10 px-6 text-sm bg-[#FF5733] text-white rounded  duration-200 border-[#FF5733]">
                                Add Project
                            </button>
                        </form>
                    </div>
                </OutsideClickHandler>
            </div>
        </>
    );
}
